import React, { useState } from "react";
import PAndIMultiModal from "../UI/Modals/PAndI/PAndIMultiModal";
//import styles from "./CrudContentPAndI.module.scss";
import ItemFilter from "../ItemFilter/ItemFilter";
import Table from "../Table/Table";
import CustomDeleteModal from "../UI/Modals/CustomDeleteModal";
import CustomMoreInfoModal from "../UI/Modals/CustomMoreInfoModal";
import CustomFormModal from "../UI/Modals/CustomFormModal";

const CrudContentPAndI = (props) => {
  console.log("CrudContentPAndI");
  // Variable to display the delete modal
  const [show, setShow] = useState(false);
  // Variable to display the edit modal
  const [showEdit, setShowEdit] = useState(false);
  // Variable to display the add modal
  const [showAdd, setShowAdd] = useState(false);
  // Variable to display the delete modal
  const [showDisplay, setShowDisplay] = useState(false);

  const [showInvoice, setShowInvoice] = useState(false);

  const [showChange, setShowChange] = useState(false);

  // Variable with the current item which is selected
  const [item, setItem] = useState("");

  // Create a copy of the headers object and delete the last index
  const headers = Object.assign([], props.header).splice(
    0,
    props.header.length - 1
  );
  // Accept the header array
  const header = props.header;

  const initialPAndIObject = {
    policy_number: "",
    fixed_premium: "",
    fixed_premium_corp: "",
    insurance_start: "",
    payment_method: "",
    tax: "",
    brokerage: "",
    corporation: "",
    ship: "",
    tax_free: "",
    termination: "",
    fifty_one_sum: "",
    insurance_period_from: "",
    insurance_period_to: "",
  };

  // Poolname
  const [pAndI, setPAndI] = useState(initialPAndIObject);
  const [preventNext, setPreventNext] = useState(true);
  const [division, setDivision] = useState("");
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);

  // Function to handle the delete of an specific entry
  const handleDelete = () => {
    console.log(item);
    props.onDelete(item);
    setShow(false);
  };

  // The functions to open and close the modal
  const handleClose = () => setShow(false);
  const handleShow = (datum) => {
    setItem(datum);
    setShow(true);
  };

  // Function to handle the edit of the items
  const handleEdit = (e) => {
    const data = { ...e };
    props.onEditItem(data);
  };

  // Functions to close and open the modal
  const handleCloseEdit = () => {
    setPAndI(undefined);
    setShowEdit(false);
  };

  const handleShowEdit = (data) => {
    // Create a copy of the data item and replace all comma with dot
    const item = { ...data };
    props.onEditItemReceive(item);
    setPAndI(item);
    setShowEdit(true);
  };

  // Function to handle adding of new items to the table
  const handleAdd = (e) => {
    console.log(e);
    const data = { ...e };
    setPAndI(data);
    setPreventNext(false);
    console.log(data);
    props.onAddItem(data);
  };

  // Function to close and open the modal
  const handleCloseAdd = () => {
    setPreventNext(true);
    setPAndI(undefined);
    setShowAdd(false);
  };
  const handleShowAdd = () => {
    setShowAdd(true);
  };

  // Function to handle adding of new items to the table
  const handleChange = (e) => {
    console.log(e);
    const data = { ...e };
    console.log(data);
    props.onChangeItem(data);
    handleCloseChange();
  };

  // Function to close and open the modal
  const handleCloseChange = () => {
    setShowChange(false);
  };
  const handleShowChange = () => {
    setShowChange(true);
  };

  // Function to close and open the modal
  const handleCloseDisplay = () => setShowDisplay(false);
  const handleShowDisplay = (data) => {
    props.onDisplayItemReceive(data);
    setShowDisplay(true);
  };

  // Methode to get the filter value out of the input field
  const handleFilter = (e) => {
    var filter = { filter: e.target.value };
    props.onFilter(filter);
  };

  const handleCloseInvoice = () => {
    setShowInvoice(false);
  };
  const handleShowInvoice = (item) => {
    setHasPaymentMethod(item.payment_method !== '' ? true : false);
    props.dueDatesIsDisabled(item.payment_method !== '' ? true : false)
    setDivision(item);
    setShowInvoice(true);
  };

  const handleInvoiceCreation = (dueDatesList) => {
    handleCloseInvoice();
    const newDivision = { ...division };
    if (dueDatesList !== null) {
      const invoiceCreationData = { div: newDivision, dueDatesList: [] };
      props.onInvoiceCreation(invoiceCreationData);
    } else {
      const invoiceCreationData = {
        div: newDivision,
        dueDatesList: dueDatesList,
      };
      props.onInvoiceCreation(invoiceCreationData);
    }
  };

  const pAndIObject =
    props.pAndI && Object.keys(props.pAndI).length === 0 ? pAndI : props.pAndI;

  return (
    <>
      <div>
        <h2>{props.heading}</h2>
        <div className="col">
          <ItemFilter
            placeholder={props.placeholder}
            onChange={handleFilter}
            onAdd={handleShowAdd}
            onAddChange={handleShowChange}
            onYearChange={props.onYearChange}
            hasYearFilter={props.hasYearFilter}
            changeDivision
            add={props.add}
          />
          <Table
            headers={headers}
            header={header}
            items={props.items}
            onEdit={handleShowEdit}
            onDelete={handleShow}
            delete={props.delete}
            onDisplay={handleShowDisplay}
            tableStyle="tableContainer"
            attr={props.attr}
            moreInfo={props.moreInfo}
            signArray={props.signArray}
            edit={props.edit}
            onInvoice={handleShowInvoice}
            invoice={props.invoice}
            loading={props.loading}
            unauthorized={props.unauthorized}
            error={props.error}
          />
        </div>
      </div>

      <CustomDeleteModal
        modalTitle={props.modalTitle}
        modalBody={props.modalBody}
        onClose={handleClose}
        onDelete={handleDelete}
        onHide={handleClose}
        show={show}
      />

      <PAndIMultiModal
        show={showAdd}
        onSubmit={handleAdd}
        form={props.formAdd}
        modalTitle={props.modalTitleAdd}
        showFranchise={showAdd}
        onSubmitFranchise={handleAdd}
        onHide={handleCloseAdd}
        pAndI={props.pAndI}
        preventNext={preventNext}
        isEditing={false}
      />
      {props.edit && (
        <PAndIMultiModal
          show={showEdit}
          onSubmit={handleEdit}
          form={props.form}
          modalTitle={props.modalTitleEdit}
          showFranchise={showEdit}
          onSubmitFranchise={handleEdit}
          onHide={handleCloseEdit}
          pAndI={pAndIObject}
          isEditing={true}
        />
      )}

      <CustomFormModal
        show={showChange}
        onSubmit={handleChange}
        form={props.formChange}
        onHide={handleCloseChange}
        modalTitle="P & I Änderung hinzufügen"
      />

      <CustomMoreInfoModal
        show={showDisplay}
        items={props.displayItems}
        onHide={handleCloseDisplay}
        onClose={handleCloseDisplay}
        modalTitle={props.modalTitleAdd}
        hasTable={true}
        attr={{ 0: "name" }}
        header={props.modalHeader}
        headers={props.modalHeaders}
      />

      {props.invoice && (
        <CustomFormModal
          show={showInvoice}
          onSubmit={handleInvoiceCreation}
          leftButton="Schließen"
          rightButton="Direkt generieren"
          onLeftBtn={handleCloseInvoice}
          onRightBtn={handleInvoiceCreation}
          form={
            <div>
              <p>
                <b>
                  Es ist immer das Zeitraum von und bis anzugeben. Bei
                  quartalsweiser Zahlung würde für das erste Quartal 01.01 -
                  31.3 angegeben werden.
                </b>
              </p>
              {props.dueDatesForm}
            </div>
          }
          onHide={handleCloseInvoice}
          modalTitle={props.invoiceModalHeader}
          footer
          hasPaymentMethod={hasPaymentMethod}
        />
      )}
    </>
  );
};

export default CrudContentPAndI;
